export interface IAction {
  type: string;
}

export type DispatchFunction = (action: IAction) => void;

type CreatePlugin = (
  defaultProps: object,
  view: (dispatch: DispatchFunction, model: object) => () => void,
  reducer: (action: IAction, model: object) => object
) => (props: object) => void;

// High order function to create a Plugin, that takes `props`, `view`, `reducer`
// props: is the internal state
// view: is the render
// reducer: which is a reducer that modifies the state
export const createPlugin: CreatePlugin = (defaultProps, view, reducer) => (
  props: object
): void => {
  let model: object = {
    ...defaultProps,
    ...props,
  };
  let cleanup: () => void;
  // create our dispatch function that will update the model and
  // run the view function after each dispatch
  const dispatch: DispatchFunction = (action) => {
    // clean up the view first
    if (cleanup) {
      cleanup();
    }

    // Update the model based on the current action
    model = reducer(action, model);

    // Update the view and pass along the dispatch function and model
    // and recieve the cleanup method
    cleanup = view(dispatch, model);
  };

  // Update the view and pass along the dispatch function and model
  // and recieve the cleanup method
  cleanup = view(dispatch, model);
};
